// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>13</span>&nbsp;&nbsp;Your way, O God, is holy;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;who is so great a god as our God?<br> </p> </div></div>";
// Exports
module.exports = code;